import _ from 'lodash';
import React, {Fragment} from 'react';
import config from 'client/shared/config';
import autobind from 'autobind-decorator';
import { inject, observer } from 'mobx-react';
import { DeleteButton } from 'client/shared/components';

import OptionsButton from 'client/shared/components/options-button';

@inject('songsStore', 'userStore', 'apiStore')
@observer
export default class SongOptions
extends React.Component {
	constructor(props) {
		super(props);
		this.state = {active: false, lastTarget: null}
	}

	render () {
		const { optionsTheme = 'dark', layout = 'menu' } = this.props;

		if (layout === 'inline') {
			return (
				<div className="song-row-actions-inline">
					{
						this.renderListButton({
							icon: 'fas fa-pencil',
							label: 'Edit',
							ariaLabel: 'Edit track',
							onClick: this.onEditClick,
							className: 'song-row-action-btn'
						})
					}
					{
						this.renderListButton({
							icon: 'fas fa-trash',
							label: 'Delete',
							ariaLabel: 'Delete track',
							onClick: this.onDeleteClick,
							className: 'song-row-action-btn'
						})
					}
				</div>
			);
		}

		return (
			<div style={{position: 'absolute', top:'10%', right: 0}}>
				<div style={{position: 'relative'}} onMouseUp={ this.onMouseUp } onBlur={ this.onBlur }>
					<OptionsButton
						id="OPTIONSBUTTON"
						menuOnLeft
						className={ `list-options left ${ optionsTheme }` }
					>
					</OptionsButton>
					{this.state.active && this.renderOptions()}
				</div>
			</div>
		);
	}

	renderOptions () {
		return (
			<div className="cell auto list-options-menu popup-menu" style={{
				textAlign: 'left',
				width: '6vw',
				display: 'block',
				position: 'absolute',
				left: '-7vw',
				top: '-0.2vh',
			}}>
				{
					this.renderListButton({
						icon: 'fas fa-pencil',
						label: 'Edit',
						ariaLabel: 'edit',
						onClick: this.onEditClick
					})
				}
				{/* {
					this.renderListButton({
						icon: 'fas fa-wrench',
						label: 'Adjust Song Preview',
						ariaLabel: 'adjust',
						onClick: this.onAdjustClick
					})
				} */}
				{
					this.renderListButton({
						icon: 'fas fa-trash',
						label: 'Delete',
						ariaLabel: 'delete',
						onClick: this.onDeleteClick
					})
				}
			</div>
		);
	}

	@autobind
	renderListButton ({
		icon,
		position,
		onClick,
		label,
		className = 'larger-options',
		ariaLabel,
		attrs = {}
	}) {
		return (
			<div key={ position }>
				<button
					aria-label={ariaLabel}
					{ ...attrs }
					onClick={() => onClick()}
					className={ `button tertiary clear margin-bottom-0 ${className}` }
				>
					<span className={ `${icon} icon` }></span> { label }
				</button>
			</div>
		);
	}

	@autobind 
	onEditClick () {
		const { songsStore, song } = this.props;
		songsStore.songToEdit = song;
		this.setState({active: false});
	}
	
	// @autobind 
	// onAdjustClick () {
	// 	const { songsStore, song } = this.props;
	// 	songsStore.songToEdit = song;
	// 	this.setState({active: false});
	// }
	
	@autobind
	onDeleteClick () {
		const {song} = this.props;
		song.delete();
	}

	@autobind
	onMouseUp (evt) {
		this.setState({active: true});
		evt.stopPropagation();
	}

	@autobind
	onBlur (evt) {
		console.log(this.state.lastTarget)

		if(evt.relatedTarget === null) {
			this.setState({active: false});
		}
		else if(!evt.relatedTarget.classList.contains('button' && 'tertiary')) {
			this.setState({active: false});
		}
		evt.stopPropagation();
	}
}
